import React from 'react';

import Typewriter from "typewriter-effect";
import './Text.css'
const HeroText = () => {
    
    return (
        <div id='text-anim'>
             <Typewriter
    options={{
        strings: ["I'M SHAHIDUL ISLAM"],
        autoStart: true,
        loop: true,
      }}
  onInit={(typewriter)=> {

  typewriter
   
  .typeString("I'M SHAHIDUL ISLAM")
    
  .pauseFor(1000)
  .deleteAll()
  .typeString("I'M SHAHIDUL ISLAM")
  .start();
                }}
                
  />
       </div>
    );
};

export default HeroText;